<template>
  <v-app>
    <v-app-bar app color="primary" dark elevation="4" dense>
      <v-toolbar-title class="d-flex align-center">
        <v-icon class="mr-2 d-none d-sm-flex">mdi-calendar-heart</v-icon>
        <span class="toolbar-title">
          {{ $store.state.nombreInstitucion || "Sistema de Turnos" }}
        </span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-chip color="white" text-color="primary" small class="d-none d-sm-flex">
        <v-icon left x-small>mdi-clock-outline</v-icon>
        Reserva Online
      </v-chip>
    </v-app-bar>

    <v-main class="app-background">
      <router-view />
    </v-main>

    <v-footer app color="primary" dark class="pa-2">
      <v-row align="center" justify="center" no-gutters>
        <v-col cols="12" class="text-center">
          <span class="text-caption">
            © {{ new Date().getFullYear() }} - Sistema de Gestión de Turnos
          </span>
        </v-col>
      </v-row>
    </v-footer>
  </v-app>
</template>

<style>
html {
  scrollbar-gutter: stable;
}
.app-background {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  min-height: 100vh;
}

.toolbar-title {
  font-size: 1.1rem;
  font-weight: 500;
}

/* Responsive toolbar */
@media (max-width: 600px) {
  .toolbar-title {
    font-size: 0.9rem;
  }
}

@media (max-width: 400px) {
  .toolbar-title {
    font-size: 0.8rem;
  }
}

/* Animaciones globales */
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.v-card {
  animation: fadeIn 0.5s ease-out;
}

/* Mejoras de scroll en móviles */
* {
  -webkit-overflow-scrolling: touch;
}

/* SOLUCIÓN DEFINITIVA PARA EL SCROLL DEL MODAL */
/* Ocultar overflow del dialog - SOLUCIÓN PRINCIPAL */
/* .v-dialog {
  overflow-y: hidden !important;
  overflow-x: hidden !important;
} */

.v-dialog__content {
  overflow-y: hidden !important;
}

/* Asegurar que el card interno tenga scroll si es necesario */
.v-dialog > .v-card {
  overflow-y: auto;
  max-height: 90vh;
}

.v-dialog--scrollable .v-card__text {
  overflow-y: auto;
}

/* Forzar scrollbar siempre visible para evitar el salto */
html {
  overflow-y: scroll !important;
  width: 100%;
}

body {
  overflow-x: hidden;
  width: 100%;
}

/* Cuando Vuetify abre un overlay/dialog */
.v-application--wrap {
  min-height: 100vh;
}

/* Prevenir scroll en el overlay */
.v-overlay--active ~ .v-application--wrap {
  overflow: hidden;
  position: fixed;
  width: 100%;
}

:deep(.v-dialog) {
  overflow-y: hidden !important;
}

/* Ocultar scrollbar del body cuando hay dialog activo */
body:has(.v-dialog--active) {
  overflow: hidden !important;
}

/* Fallback para navegadores que no soportan :has() */
.v-dialog__content--active {
  position: fixed;
  overflow-y: scroll !important;
}
</style>

<script>
export default {
  name: "App",
};
</script>
